/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiPaginatedResponseOfVideoAssetResponse } from '../model';
// @ts-ignore
import { ApiResponseOfVideoAssetResponse } from '../model';
// @ts-ignore
import { VideoAssetRole } from '../model';
// @ts-ignore
import { VideoAssetUpdateBody } from '../model';
/**
 * VideoAssetsApi - axios parameter creator
 * @export
 */
export const VideoAssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a video asset in the **Vix CMS** application.
         * @param {string} assetId Asset´s identifier
         * @param {string} assetName Asset´s name
         * @param {string} assetType Asset´s type
         * @param {VideoAssetRole} videoAssetRole 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (assetId: string, assetName: string, assetType: string, videoAssetRole: VideoAssetRole, file?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('create', 'assetId', assetId)
            // verify required parameter 'assetName' is not null or undefined
            assertParamExists('create', 'assetName', assetName)
            // verify required parameter 'assetType' is not null or undefined
            assertParamExists('create', 'assetType', assetType)
            // verify required parameter 'videoAssetRole' is not null or undefined
            assertParamExists('create', 'videoAssetRole', videoAssetRole)
            const localVarPath = `/api/v1/videoAssets/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (assetId !== undefined) {
                localVarQueryParameter['assetId'] = assetId;
            }

            if (assetName !== undefined) {
                localVarQueryParameter['assetName'] = assetName;
            }

            if (assetType !== undefined) {
                localVarQueryParameter['assetType'] = assetType;
            }

            if (videoAssetRole !== undefined) {
                localVarQueryParameter['videoAssetRole'] = videoAssetRole;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the asset by filePath in the **Vix CMS** application.
         * @param {string} filePath 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByFilePath: async (filePath: string, includeDeleted?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'filePath' is not null or undefined
            assertParamExists('getByFilePath', 'filePath', filePath)
            const localVarPath = `/api/v1/videoAssets/filePath`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filePath !== undefined) {
                localVarQueryParameter['filePath'] = filePath;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the image of a video asset in the **Vix CMS** application.
         * @param {string} assetId 
         * @param {boolean} includeDeleted 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (assetId: string, includeDeleted: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getById', 'assetId', assetId)
            // verify required parameter 'includeDeleted' is not null or undefined
            assertParamExists('getById', 'includeDeleted', includeDeleted)
            const localVarPath = `/api/v1/videoAssets/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [assetType] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated: async (limit?: number, page?: number, assetType?: string, includeDeleted?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/videoAssets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (assetType !== undefined) {
                localVarQueryParameter['assetType'] = assetType;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (assetId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('remove', 'assetId', assetId)
            const localVarPath = `/api/v1/videoAssets/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assetId 
         * @param {VideoAssetUpdateBody} videoAssetUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (assetId: string, videoAssetUpdateBody: VideoAssetUpdateBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('update', 'assetId', assetId)
            // verify required parameter 'videoAssetUpdateBody' is not null or undefined
            assertParamExists('update', 'videoAssetUpdateBody', videoAssetUpdateBody)
            const localVarPath = `/api/v1/videoAssets/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(videoAssetUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VideoAssetsApi - functional programming interface
 * @export
 */
export const VideoAssetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VideoAssetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a video asset in the **Vix CMS** application.
         * @param {string} assetId Asset´s identifier
         * @param {string} assetName Asset´s name
         * @param {string} assetType Asset´s type
         * @param {VideoAssetRole} videoAssetRole 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(assetId: string, assetName: string, assetType: string, videoAssetRole: VideoAssetRole, file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfVideoAssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(assetId, assetName, assetType, videoAssetRole, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the asset by filePath in the **Vix CMS** application.
         * @param {string} filePath 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByFilePath(filePath: string, includeDeleted?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfVideoAssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByFilePath(filePath, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the image of a video asset in the **Vix CMS** application.
         * @param {string} assetId 
         * @param {boolean} includeDeleted 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(assetId: string, includeDeleted: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfVideoAssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(assetId, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [assetType] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginated(limit?: number, page?: number, assetType?: string, includeDeleted?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPaginatedResponseOfVideoAssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginated(limit, page, assetType, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(assetId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} assetId 
         * @param {VideoAssetUpdateBody} videoAssetUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(assetId: string, videoAssetUpdateBody: VideoAssetUpdateBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfVideoAssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(assetId, videoAssetUpdateBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VideoAssetsApi - factory interface
 * @export
 */
export const VideoAssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VideoAssetsApiFp(configuration)
    return {
        /**
         * Creates a video asset in the **Vix CMS** application.
         * @param {string} assetId Asset´s identifier
         * @param {string} assetName Asset´s name
         * @param {string} assetType Asset´s type
         * @param {VideoAssetRole} videoAssetRole 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(assetId: string, assetName: string, assetType: string, videoAssetRole: VideoAssetRole, file?: any, options?: any): AxiosPromise<ApiResponseOfVideoAssetResponse> {
            return localVarFp.create(assetId, assetName, assetType, videoAssetRole, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the asset by filePath in the **Vix CMS** application.
         * @param {string} filePath 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByFilePath(filePath: string, includeDeleted?: boolean, options?: any): AxiosPromise<ApiResponseOfVideoAssetResponse> {
            return localVarFp.getByFilePath(filePath, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the image of a video asset in the **Vix CMS** application.
         * @param {string} assetId 
         * @param {boolean} includeDeleted 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(assetId: string, includeDeleted: boolean, options?: any): AxiosPromise<ApiResponseOfVideoAssetResponse> {
            return localVarFp.getById(assetId, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [assetType] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated(limit?: number, page?: number, assetType?: string, includeDeleted?: boolean, options?: any): AxiosPromise<ApiPaginatedResponseOfVideoAssetResponse> {
            return localVarFp.getPaginated(limit, page, assetType, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(assetId: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} assetId 
         * @param {VideoAssetUpdateBody} videoAssetUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(assetId: string, videoAssetUpdateBody: VideoAssetUpdateBody, options?: any): AxiosPromise<ApiResponseOfVideoAssetResponse> {
            return localVarFp.update(assetId, videoAssetUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VideoAssetsApi - interface
 * @export
 * @interface VideoAssetsApi
 */
export interface VideoAssetsApiInterface {
    /**
     * Creates a video asset in the **Vix CMS** application.
     * @param {string} assetId Asset´s identifier
     * @param {string} assetName Asset´s name
     * @param {string} assetType Asset´s type
     * @param {VideoAssetRole} videoAssetRole 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApiInterface
     */
    create(assetId: string, assetName: string, assetType: string, videoAssetRole: VideoAssetRole, file?: any, options?: any): AxiosPromise<ApiResponseOfVideoAssetResponse>;

    /**
     * Retrieves the asset by filePath in the **Vix CMS** application.
     * @param {string} filePath 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApiInterface
     */
    getByFilePath(filePath: string, includeDeleted?: boolean, options?: any): AxiosPromise<ApiResponseOfVideoAssetResponse>;

    /**
     * Retrieves the image of a video asset in the **Vix CMS** application.
     * @param {string} assetId 
     * @param {boolean} includeDeleted 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApiInterface
     */
    getById(assetId: string, includeDeleted: boolean, options?: any): AxiosPromise<ApiResponseOfVideoAssetResponse>;

    /**
     * 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [assetType] 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApiInterface
     */
    getPaginated(limit?: number, page?: number, assetType?: string, includeDeleted?: boolean, options?: any): AxiosPromise<ApiPaginatedResponseOfVideoAssetResponse>;

    /**
     * 
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApiInterface
     */
    remove(assetId: string, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {string} assetId 
     * @param {VideoAssetUpdateBody} videoAssetUpdateBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApiInterface
     */
    update(assetId: string, videoAssetUpdateBody: VideoAssetUpdateBody, options?: any): AxiosPromise<ApiResponseOfVideoAssetResponse>;

}

/**
 * VideoAssetsApi - object-oriented interface
 * @export
 * @class VideoAssetsApi
 * @extends {BaseAPI}
 */
export class VideoAssetsApi extends BaseAPI implements VideoAssetsApiInterface {
    /**
     * Creates a video asset in the **Vix CMS** application.
     * @param {string} assetId Asset´s identifier
     * @param {string} assetName Asset´s name
     * @param {string} assetType Asset´s type
     * @param {VideoAssetRole} videoAssetRole 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    public create(assetId: string, assetName: string, assetType: string, videoAssetRole: VideoAssetRole, file?: any, options?: any) {
        return VideoAssetsApiFp(this.configuration).create(assetId, assetName, assetType, videoAssetRole, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the asset by filePath in the **Vix CMS** application.
     * @param {string} filePath 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    public getByFilePath(filePath: string, includeDeleted?: boolean, options?: any) {
        return VideoAssetsApiFp(this.configuration).getByFilePath(filePath, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the image of a video asset in the **Vix CMS** application.
     * @param {string} assetId 
     * @param {boolean} includeDeleted 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    public getById(assetId: string, includeDeleted: boolean, options?: any) {
        return VideoAssetsApiFp(this.configuration).getById(assetId, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [assetType] 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    public getPaginated(limit?: number, page?: number, assetType?: string, includeDeleted?: boolean, options?: any) {
        return VideoAssetsApiFp(this.configuration).getPaginated(limit, page, assetType, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    public remove(assetId: string, options?: any) {
        return VideoAssetsApiFp(this.configuration).remove(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} assetId 
     * @param {VideoAssetUpdateBody} videoAssetUpdateBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    public update(assetId: string, videoAssetUpdateBody: VideoAssetUpdateBody, options?: any) {
        return VideoAssetsApiFp(this.configuration).update(assetId, videoAssetUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}
